import React from 'react';
import { Icon, Button } from '@ss/mtd-react';
import { Header } from '../../components';
import './index.scss';

class Success extends React.Component {
  dataChanged: boolean;

  formRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.dataChanged = false;
    this.formRef = React.createRef();
    this.state = {};
  }

  handleClick = () => {
    const tenantUid = window.location.hash.split('/')[2];
    window.location.hash = `#/candidate/${tenantUid}/`;
  };

  render() {
    return (
      <div className="success">
        <Header />
        <div className="success__wrapper">
          <Icon className="success__icon" type="success-circle" />
          <div className="success__title">提交成功</div>
          <div className="success__subtitle">您已完成个人信息填写，请耐心等待HR审核</div>
          <Button onClick={this.handleClick}>查看资料</Button>
        </div>
      </div>
    );
  }
}

export default Success;
